// extracted by mini-css-extract-plugin
export default {"postContainer":"Post_postContainer__7cvOF","close":"Post_close__qsEs+"};